import { forwardRef } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";

import {
  type TDialogContentElement,
  type TDialogContentProps,
} from "@/ui/components/overlay/Dialog/Dialog.config";
import { DialogOverlay } from "@/ui/components/overlay/Dialog/DialogOverlay";
import { DialogPortal } from "@/ui/components/overlay/Dialog/DialogPortal";
import { DialogClose } from "@/ui/components/overlay/Dialog/DialogClose";
import { cn } from "@/ui/lib/utils";

export const DialogContent = forwardRef<TDialogContentElement, TDialogContentProps>(
  (
    {
      children,
      className,
      ...props
    },
    ref,
  ) => (
    <DialogPortal>
      <DialogOverlay />
      <DialogPrimitive.Content
        data-component="DialogContent"
        ref={ref}
        className={cn(
          "fixed left-1/2 top-1/2 z-50 grid w-[calc(100%-2rem)] max-w-lg -translate-x-1/2 -translate-y-1/2 gap-4 border border-solid border-dialog bg-surface-default p-4 shadow-lg duration-200 rounded-sys-sm",
          "data-[state=open]:animate-in data-[state=closed]:animate-out",
          "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
          "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
          "data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%]",
          "data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
          className,
        )}
        {...props}
      >
        { children }
        <DialogClose />
      </DialogPrimitive.Content>
    </DialogPortal>
  ),
);

DialogContent.displayName = DialogPrimitive.Content.displayName;
